<mat-form-field appearance="outline" floatLabel="always" [class.mat-form-field-readonly]="readonly" [class.ng-valid]="errors === ''" [id]="idPrefix + '-form-field'">

  <!-- Label -->
  <mat-label [id]="idPrefix + '-label'">
    @if (labelTemplate) {
      <template [ngTemplateOutlet]="labelTemplate"></template>
    } @else {
      {{label}}
    }
  </mat-label>

  <!-- Input -->
  <input lcTestId matInput [formControl]="formControl" [matAutocomplete]="auto" [placeholder]="placeholderText">

  <mat-autocomplete #auto="matAutocomplete" lcTestId panelWidth="auto" (optionSelected)='updateSelection($event.option.value)'>
    @if (autoCompleteOptions && autoCompleteOptions.length > 0) {
      @for (data of autoCompleteOptions; track data) {
        <mat-option [title]="data.text" [value]="data">
          <span>{{ data.text }}</span>
        </mat-option>
      }
    }
  </mat-autocomplete>
  <!-- Hint-->
  <mat-hint class="w-100" [id]="idPrefix + '-hint'">
    @if (hintTemplate) {
      <template [ngTemplateOutlet]="hintTemplate"></template>
    } @else {
      {{hint}}
    }
  </mat-hint>

  <!-- Error -->
  @if (formControl && formControl.invalid) {
    <mat-error [id]="idPrefix + '-error'" [innerHTML]="errors" />
  }

  <!-- Suffix -->
  @if (suffix || suffixTemplate) {
    <div matSuffix>
      @if (suffixTemplate) {
        <template [ngTemplateOutlet]="suffixTemplate" ></template>
      } @else {
        @if (suffix) {
          <span>{{suffix}}</span>
        }
      }
    </div>
  }
</mat-form-field>

